__turbopack_context__.v({
  "consentBannerButtonRow": "CookieConsentBanner-module__O_6bvW__consentBannerButtonRow",
  "consentBannerRoot": "CookieConsentBanner-module__O_6bvW__consentBannerRoot",
  "consentBannerSection": "CookieConsentBanner-module__O_6bvW__consentBannerSection",
});
